import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { keyframes } from 'tss-react';

type DotProps = {
  delay: number;
  color: string;
};

const dotAnimation = keyframes`
0% {
  transform: scale(1);
}
100% {
  transform: scale(1.5);
}
`;

const useStyle = (delay: number, color: string) =>
  makeStyles(() => ({
    dot: {
      animation: `${dotAnimation} .5s ease-in-out .5s infinite alternate`,
      animationDelay: `${delay}s`,
      width: '7px',
      height: '7px',
      borderRadius: '7px',
      backgroundColor: `${color}`,
    },
  }))();

export const Dot = ({ delay, color = PRIMARY_BLUE }: DotProps) => {
  const { classes } = useStyle(delay, color);
  return <div className={classes.dot} />;
};
